import { Stack, Typography } from '@mui/material';
import { ResultRow } from './ResultRow';
import ArmChart from './ArmChart';
import { useTranslation } from 'react-i18next';

const pitchDomain = [-2, 2];
export function ArmTest({ armsPitchData, armResult }) {
  const { t } = useTranslation();

  const formatData = (data) => {
    return data.map((value, index) => ({ timestamp: index, val: value }));
  };

  return (
    <>
      <Stack spacing={5} justifyContent="space-between">
        {armsPitchData?.length > 0 && (
          <Stack>
            <Typography variant="h6" color="textPrimary">
              Pitch
            </Typography>
            <ArmChart domain={pitchDomain} width={500} data={formatData(armsPitchData)} x_label="timestamp" y_label="val" />
          </Stack>
        )}
        <ResultRow title="Arm Weakness" value={t(armResult)} />
      </Stack>
    </>
  );
}
